import { Media } from '@syconium/little-miss-figgy'

import { Body as FilterPanelBody } from '../sections/CollectionGridSection/FilterPanel/styles'
import { FilterColumn } from '../sections/CollectionGridSection/styles'

import { MobileFilterPanelSkeleton } from './MobileFilterPanelSkeleton'

import type { ReactElement } from 'react'

export const CollectionGridSectionFiltersSkeleton = (): ReactElement => {
  return (
    <FilterColumn desktop={2.5}>
      <FilterPanelBody>
        <Media lessThan='md'>
          <MobileFilterPanelSkeleton />
        </Media>
      </FilterPanelBody>
    </FilterColumn>
  )
}
